import { createSelector } from "reselect";

const getUserMandatesList = (state: any) => state.getIn(['userMandateReducer', 'userMandatesList']);
const getUserMandateListFailure = (state: any) => state.getIn(["userMandateReducer", "fetchUserMandateListFailure"]);
const getMandateActivateConfig= (state: any) => state.getIn(["userMandateReducer", "mandateActivateConfig"]);

const UserMandateSelector = createSelector(
  [getUserMandatesList, getUserMandateListFailure, getMandateActivateConfig],
  (
    userMandatesList,
    fetchUserMandateListFailure,
    mandateActivateConfig
  ) => ({
    userMandatesList,
    fetchUserMandateListFailure,
    mandateActivateConfig
  })
);
export default UserMandateSelector;